import type React from 'react';

import { usePromoteCtaDisplayed } from '#src/app/pages/petitionDetails/shared/hooks';

import { SideSignedNonPromotableContainer } from './SideSignedNonPromotable';
import { SideSignedPromotableContainer } from './SideSignedPromotable';

export const SideSignedContainer: React.FC = () => {
	const ctaDisplayed = usePromoteCtaDisplayed();

	return ctaDisplayed ? <SideSignedPromotableContainer /> : <SideSignedNonPromotableContainer />;
};
